<template>
  <div id="apply" :class="plat">
    <div class="ap-box" v-if="$store.state.activeTopTab == 1">
      <div class="ap-title">
        <span>申请职位</span>
        <span v-show="post">-{{ post }}</span>
      </div>
      <div class="ap-tip">请填写真实信息，以便后续沟通联系</div>
      <div class="ap-body">
        <ul>
          <li>
            <div class="ap-td-0">
              姓名
              <font>*</font>
            </div>
            <div class="ap-td-1">
              <input type="text" ref="name" name="name" maxlength="40" @input="inputLimit" placeholder="请输入" />
            </div>
          </li>
          <li>
            <div class="ap-td-0">
              学校
              <font>*</font>
            </div>
            <div class="ap-td-1">
              <input type="text" ref="school" name="school" maxlength="11" placeholder="请输入" />
            </div>
          </li>
          <li>
            <div class="ap-td-0">
              专业
              <font>*</font>
            </div>
            <div class="ap-td-1">
              <input type="text" ref="major" name="major" maxlength="11" placeholder="请输入" />
            </div>
          </li>
          <li>
            <div class="ap-td-0">
              电话
              <font>*</font>
            </div>
            <div class="ap-td-1">
              <input type="tel" pattern="\d*" ref="phone" name="phone" maxlength="40" placeholder="请输入" />
            </div>
          </li>
          <li>
            <div class="ap-td-0">
              邮箱
              <font>*</font>
            </div>
            <div class="ap-td-1">
              <input type="text" ref="email" name="email" maxlength="40" @input="inputLimit" placeholder="请输入" />
            </div>
          </li>
          <li>
            <div class="ap-td-0">
              附件简历
              <font>*</font>
            </div>
            <div :style="msy" class="ap-upload-m">
              <div class="upload-xin" ref="uploadXinM" @click="selectFile">
                <img src="../../assets/icon_xinzeng.png" alt />
              </div>
              <div class="upload-you hide" ref="uploadYouM">
                <div class="ff f1">
                  <img src="../../assets/pdf.png" alt />
                </div>
                <div class="ff f2">
                  <img src="../../assets/doc.png" alt />
                </div>
                <div class="ff f3">
                  <img src="../../assets/docx.png" alt />
                </div>
                <div class="h3">个人简历.pdf</div>
                <div class="ti">
                  <img @click="deleteBtn" src="../../assets/icon_delete.png" alt />
                </div>
              </div>
            </div>
            <div :style="psy" class="ap-upload-pc">
              <div class="upload-xin" ref="uploadXin">
                <div class="h3">将你的文件拖拽到此处</div>
                <div class="bx" @click="selectFile">选择文件</div>
                <div class="ti">将文件大小控制在6M以内，支持格式.doc、.docx、.pdf</div>
              </div>
              <div class="upload-you hide" ref="uploadYou">
                <div class="ff f1">
                  <img src="../../assets/pdf.png" alt />
                </div>
                <div class="ff f2">
                  <img src="../../assets/doc.png" alt />
                </div>
                <div class="ff f3">
                  <img src="../../assets/docx.png" alt />
                </div>
                <div class="h3">个人简历.pdf</div>
                <div class="ti">
                  <span style="color: #27a2c4;" @click="selectFile">更新</span>&nbsp;&nbsp;|&nbsp;&nbsp;
                  <span style="color: red;" @click="deleteBtn">删除</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="ap-foot">
        <button class="btn cancel" @click.stop="cancel">取消</button>
        <button class="btn submit" @click="submitX" :disabled="btnDisabled">提交</button>
      </div>
    </div>
    <div class="ap-box" v-if="$store.state.activeTopTab == 4">
      <div class="ap-title">
        <span>申请职位</span>
        <span v-show="post">-{{ post }}</span>
      </div>
      <div class="ap-tip">请填写真实信息，以便后续沟通联系</div>
      <div class="ap-body">
        <ul>
          <li>
            <div class="ap-td-0">
              姓名
              <font>*</font>
            </div>
            <div class="ap-td-1">
              <input type="text" ref="name" name="name" maxlength="40" @input="inputLimit" placeholder="请输入" />
            </div>
          </li>
          <li>
            <div class="ap-td-0">
              电话
              <font>*</font>
            </div>
            <div class="ap-td-1">
              <input type="tel" pattern="\d*" ref="phone" name="phone" maxlength="40" placeholder="请输入" />
            </div>
          </li>
          <li>
            <div class="ap-td-0">
              邮箱
              <font>*</font>
            </div>
            <div class="ap-td-1">
              <input type="text" ref="email" name="email" maxlength="40" @input="inputLimit" placeholder="请输入" />
            </div>
          </li>
          <li>
            <div class="ap-td-0">
              附件简历
              <font>*</font>
            </div>
            <div :style="msy" class="ap-upload-m">
              <div class="upload-xin" ref="uploadXinM" @click="selectFile">
                <img src="../../assets/icon_xinzeng.png" alt />
              </div>
              <div class="upload-you hide" ref="uploadYouM">
                <div class="ff f1">
                  <img src="../../assets/pdf.png" alt />
                </div>
                <div class="ff f2">
                  <img src="../../assets/doc.png" alt />
                </div>
                <div class="ff f3">
                  <img src="../../assets/docx.png" alt />
                </div>
                <div class="h3">个人简历.pdf</div>
                <div class="ti">
                  <img @click="deleteBtn" src="../../assets/icon_delete.png" alt />
                </div>
              </div>
            </div>
            <div :style="psy" class="ap-upload-pc">
              <div class="upload-xin" ref="uploadXin">
                <div class="h3">将你的文件拖拽到此处</div>
                <div class="bx" @click="selectFile">选择文件</div>
                <div class="ti">将文件大小控制在6M以内，支持格式.doc、.docx、.pdf</div>
              </div>
              <div class="upload-you hide" ref="uploadYou">
                <div class="ff f1">
                  <img src="../../assets/pdf.png" alt />
                </div>
                <div class="ff f2">
                  <img src="../../assets/doc.png" alt />
                </div>
                <div class="ff f3">
                  <img src="../../assets/docx.png" alt />
                </div>
                <div class="h3">个人简历.pdf</div>
                <div class="ti">
                  <span style="color: #27a2c4;" @click="selectFile">更新</span>&nbsp;&nbsp;|&nbsp;&nbsp;
                  <span style="color: red;" @click="deleteBtn">删除</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="ap-foot">
        <button class="btn cancel" @click.stop="cancel">取消</button>
        <button class="btn submit" @click="submitS" :disabled="btnDisabled">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import cmJs from '@/components/common/common.js'

export default {
  // 本组件自定义的属性
  props: {
    post: String,
    company: String,
    postId: String,
    recruitmentId: String,
    positionId: String
  },
  data() {
    return {
      plat: `plat-${this.$store.state.plat}`,
      psy: { display: this.$store.state.plat === 'Web' ? '' : 'none' },
      msy: { display: this.$store.state.plat === 'Mobile' ? '' : 'none' },
      selectedFile: undefined,
      type: null,
      btnDisabled: false
    }
  },
  mounted() {
    // console.log('得到的岗位信息是：', this.post, this.company);
    let This = this;
    if (this.$store.state.plat === 'Web') {
      // 文件拖拽
      this.$refs.uploadXin.addEventListener("dragenter", function (e) {
        e.preventDefault();
        e.stopPropagation();
      }, false);

      this.$refs.uploadXin.addEventListener("dragover", function (e) {
        e.preventDefault();
        e.stopPropagation();
      }, false);

      this.$refs.uploadXin.addEventListener("dragleave", function (e) {
        e.preventDefault();
        e.stopPropagation();
      }, false);

      this.$refs.uploadXin.addEventListener("drop", function (e) {
        e.preventDefault();
        e.stopPropagation();
        let files = e.dataTransfer && e.dataTransfer.items;
        if (!files) return false;
        if (files.length !== 0 && files[0]['kind'] === 'file' && files[0].webkitGetAsEntry().isFile) {
          cmJs.selectFileRule(files[0].getAsFile(), This.selectedCB);
        }
      })
    }
    cmJs.deleteUploadify();
    this.type = this.GetQueryString('type')
    console.info(this.type)
  },
  methods: {
    //判断上个页面传过来的参数
    GetQueryString(name) {
      var after = window.location.hash.split("?")[1];
      if (after) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = after.match(reg);
        if (r != null) {
          return decodeURIComponent(r[2]);
        }
        else {
          return null;
        }
      }
    },
    getCursorPos(obj) {
      var CaretPos = 0; // IE Support
      if (document.selection) {
        obj.focus();
        var Sel = document.selection.createRange();
        Sel.moveStart('character', -obj.value.length);
        CaretPos = Sel.text.length;
      } else if (obj.selectionStart || obj.selectionStart == '0') // Firefox/Safari/Chrome/Opera support
        CaretPos = obj.selectionEnd;
      return CaretPos;
    },
    setCursorPos(obj, pos) {
      if (obj.setSelectionRange) {//Firefox/Safari/Chrome/Opera
        obj.focus();
        obj.setSelectionRange(pos, pos);
      } else if (obj.createTextRange) { // IE
        var range = obj.createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos);
        range.select();
      }
    },
    inputLimit(val) {
      let obj = val.target
      var pos = this.getCursorPos(obj); //保存原始光标位置
      var temp = obj.value; //保存原始值
      // 正则匹配非中英文的字符
      this.$refs.name.value = this.$refs.name.value.replace(/[^\u4e00-\u9fa5a-zA-Z]/g, '');

      // 数字、英文、@和.
      this.$refs.email.value = this.$refs.email.value.replace(/[^@a-zA-Z0-9.]/g, '');
      pos = pos - (temp.length - obj.value.length); //当前光标位置
      this.setCursorPos(obj, pos); //设置光标
    },
    submitS(e) {
      const This = this;
      console.info(This.positionId)
      let tg = e.target;
      if (tg.classList.contains('disable')) {
        console.info('@@@@')
        return;
      }
      if (this.$refs.name.value.trim() === '') {
        cmJs.modalToast('姓名不能为空')
        return;
      }
      if (this.$refs.phone.value.trim() === '') {
        cmJs.modalToast('电话不能为空')
        return;
      }
      if (this.$refs.email.value.trim() === '') {
        cmJs.modalToast('邮箱不能为空')
        return;
      }
      if (!This.selectedFile) {
        cmJs.modalToast('附件简历不能为空')
        return;
      }
      // 13-19开头，11位，数字
      let reg = /[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!reg.test(this.$refs.phone.value)) {
        cmJs.modalToast('电话以13-19开头，且11位数字')
        return;
      }
      if (!!this.$refs.email.value.trim() && (this.$refs.email.value.trim().indexOf('.') === -1 || this.$refs.email.value.trim().indexOf('@') === -1)) {
        cmJs.modalToast('请输入正确的邮箱')
        return;
      }
      let formData = new FormData()
      this.btnDisabled = true
      setTimeout(() => {
        this.btnDisabled = false;
      }, 2000)
      if (This.selectedFile) {
        formData.append('file', This.selectedFile) // 文件
        This.$request({
          api: '/uhrm/interpolating/uploadFile',
          type: 'POST',
          param: formData,
          success: function (res) {
            if (res.code != 0) {
              cmJs.modalToast(res.msg)
              return
            }
            // console.log('成功。。', res)
            let obj = {
              name: This.$refs.name.value.trim(),
              phone: This.$refs.phone.value.trim(),
              email: This.$refs.email.value.trim(),
              url: res.data,
              recruitmentId: This.recruitmentId,
              positionId: This.positionId,
              type: This.type

            }
            This.$request({
              api: '/uhrm/website/applyPosition',
              type: 'POST',
              param: obj,
              success: function (resz) {
                if (resz.code == 0) {
                  // console.log('成功。。', resz)
                  tg.classList.add('disable')
                  tg.classList.remove('disable')
                  This.$emit('isShow', false)
                  cmJs.modalToast('', true)
                } else {
                  cmJs.modalToast(resz.msg)
                  tg.classList.remove('disable')
                }

              },
              error: function (err) {
                // console.log('失败。。', err)
                tg.classList.remove('disable')
                This.$emit('isShow', false)
                cmJs.modalToast(err.msg)
              }
            })
          },
          error: function (err) {
            // console.log('失败。。', err)
            cmJs.modalToast(err.msg)
          }
        })
      } else {
        let obj = {
          name: This.$refs.name.value.trim(),
          phone: This.$refs.phone.value.trim(),
          email: This.$refs.email.value.trim(),
          url: res.data,
          recruitmentId: This.recruitmentId,
          positionId: This.positionId,
          type: This.type
        }
        This.$request({
          api: '/uhrm/website/applyPosition',
          type: 'POST',
          param: obj,
          success: function (ress) {
            console.info(ress)
            if (ress.code == 0) {
              // console.log('成功。。', res)
              tg.classList.remove('disable')
              This.$emit('isShow', false)
              cmJs.modalToast('', true)
            } else {
              cmJs.modalToast(ress.msg)
              tg.classList.remove('disable')
            }
          },
          error: function (err) {
            // console.log('失败。。', err)
            tg.classList.remove('disable')
            This.$emit('isShow', false)
            cmJs.modalToast(err.msg)
          }
        })
      }
      


    },
    submitX(e) {
      const This = this;
      console.info(This.positionId)
      let tg = e.target;
      if (tg.classList.contains('disable')) {
        console.info('@@@@')
        return;
      }
      if (this.$refs.name.value.trim() === '') {
        cmJs.modalToast('姓名不能为空')
        return;
      }
      if (this.$refs.school.value.trim() === '') {
        cmJs.modalToast('学校不能为空')
        return;
      }
      if (this.$refs.major.value.trim() === '') {
        cmJs.modalToast('专业不能为空')
        return;
      }
      if (this.$refs.phone.value.trim() === '') {
        cmJs.modalToast('电话不能为空')
        return;
      }
      if (this.$refs.email.value.trim() === '') {
        cmJs.modalToast('邮箱不能为空')
        return;
      }
      if (!This.selectedFile) {
        cmJs.modalToast('附件简历不能为空')
        return;
      }
      // 13-19开头，11位，数字
      let reg = /[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!reg.test(this.$refs.phone.value)) {
        cmJs.modalToast('电话以13-19开头，且11位数字')
        return;
      }
      if (!!this.$refs.email.value.trim() && (this.$refs.email.value.trim().indexOf('.') === -1 || this.$refs.email.value.trim().indexOf('@') === -1)) {
        cmJs.modalToast('请输入正确的邮箱')
        return;
      }
      let formData = new FormData()
      this.btnDisabled = true
      setTimeout(() => {
        this.btnDisabled = false;
      }, 2000)
      if (This.selectedFile) {
        formData.append('file', This.selectedFile) // 文件
        This.$request({
          api: '/uhrm/interpolating/uploadFile',
          type: 'POST',
          param: formData,
          success: function (res) {
            if (res.code != 0) {
              cmJs.modalToast(res.msg)
              return
            }
            // console.log('成功。。', res)
            let obj = {
              name: This.$refs.name.value.trim(),
              school: This.$refs.school.value.trim(),
              major: This.$refs.major.value.trim(),
              phone: This.$refs.phone.value.trim(),
              email: This.$refs.email.value.trim(),
              url: res.data,
              recruitmentId: This.recruitmentId,
              positionId: This.positionId,
              type: This.type

            }
            This.$request({
              api: '/uhrm/website/applyPosition',
              type: 'POST',
              param: obj,
              success: function (resz) {
                if (resz.code == 0) {
                  // console.log('成功。。', resz)
                  tg.classList.add('disable')
                  tg.classList.remove('disable')
                  This.$emit('isShow', false)
                  cmJs.modalToast('', true)
                } else {
                  cmJs.modalToast(resz.msg)
                  tg.classList.remove('disable')
                }

              },
              error: function (err) {
                // console.log('失败。。', err)
                tg.classList.remove('disable')
                This.$emit('isShow', false)
                cmJs.modalToast(err.msg)
              }
            })
          },
          error: function (err) {
            // console.log('失败。。', err)
            cmJs.modalToast(err.msg)
          }
        })
      } else {
        let obj = {
          name: This.$refs.name.value.trim(),
          school: This.$refs.school.value.trim(),
          major: This.$refs.major.value.trim(),
          phone: This.$refs.phone.value.trim(),
          email: This.$refs.email.value.trim(),
          url: res.data,
          recruitmentId: This.recruitmentId,
          positionId: This.positionId,
          type: This.type
        }
        This.$request({
          api: '/uhrm/website/applyPosition',
          type: 'POST',
          param: obj,
          success: function (ress) {
            console.info(ress)
            if (ress.code == 0) {
              // console.log('成功。。', res)
              tg.classList.remove('disable')
              This.$emit('isShow', false)
              cmJs.modalToast('', true)
            } else {
              cmJs.modalToast(ress.msg)
              tg.classList.remove('disable')
            }
          },
          error: function (err) {
            // console.log('失败。。', err)
            tg.classList.remove('disable')
            This.$emit('isShow', false)
            cmJs.modalToast(err.msg)
          }
        })
      }
      


    },
    selectedCB(file, type) {
      let pXin, pYou;
      if (this.$store.state.plat === 'Web') {
        pXin = this.$refs.uploadXin
        pYou = this.$refs.uploadYou
      } else {
        pXin = this.$refs.uploadXinM
        pYou = this.$refs.uploadYouM
      }
      this.selectedFile = file
      pXin.classList.add('hide')
      pYou.classList.remove('hide')
      let ff = pYou.querySelectorAll('.ff')
      for (let i = 0; i < ff.length; i++) {
        ff[i].classList[i === type ? 'add' : 'remove']('show')
      }
      pYou.querySelector('.h3').innerHTML = file.name
    },
    selectFile() {
      cmJs.uploadify(this.selectedCB)
    },
    deleteBtn() {
      let pXin, pYou;
      if (this.$store.state.plat === 'Web') {
        pXin = this.$refs.uploadXin
        pYou = this.$refs.uploadYou
      } else {
        pXin = this.$refs.uploadXinM
        pYou = this.$refs.uploadYouM
      }
      this.selectedFile = undefined
      pXin.classList.remove('hide')
      pYou.classList.add('hide')
    },
    cancel() {
      this.$emit('isShow', false)
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "../../components/common/common.less";

#apply {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;

  &.plat-Mobile {
    .ap-box {
      width: 90%;
      height: 80vh;

      .ap-title {
        text-align: center;
      }

      .ap-body {
        ul {
          li {
            width: 100%;
            margin: 0 0 15px 0;
          }
        }
      }

      .ap-foot {
        line-height: 50px;

        .btn {
          width: calc(50% - 12px);
          padding: 0;
          margin-right: 0;
          height: 100%;

          &.cancel {
            margin-right: 12px;
          }

          &.submit {
            color: #fff;
            background: #ff5f00;
            border: 1px solid #ff5f00;
            margin-left: 12px;
          }
        }
      }
    }
  }

  .ap-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 664px;
    height: 680px;
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;

    .ap-title {
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      line-height: 40px;
      color: #000;
    }

    .ap-tip {
      color: #666;
      font-size: 14px;
      margin-bottom: 10px;
    }

    .ap-foot {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 16px;

      .btn {
        padding: 8px 25px;
        text-align: center;
        background: #fff;
        color: #333;
        border: 1px solid #d9d9d9;
        border-radius: 5px;
        margin-right: 15px;
        box-sizing: border-box;
        .cmSelectNone();

        &.submit {
          color: #fff;
          background: #ff5f00;
        }
      }
    }

    .ap-body {
      width: 100%;
      height: max-content;
      padding-top: 15px;
      box-sizing: border-box;
      height: calc(100% - 170px);
      margin-bottom: 15px;
      .cmScroll();

      ul {
        width: 100%;
        height: max-content;

        li {
          float: left;
          width: calc(50% - 20px);
          height: max-content;
          margin: 0 10px 25px 10px;

          .ap-td-0 {
            line-height: 28px;

            font {
              color: red;
            }
          }

          .ap-td-1 {
            line-height: 35px;
            height: 35px;

            input {
              width: 90%;
              height: 100%;
              box-sizing: border-box;
              border: 1px solid #999;
              outline: none;
              border-radius: 5px;
              padding-left: 8px;
            }

            select {
              width: 90%;
              height: 100%;
              box-sizing: border-box;
              border: 1px solid #999;
              outline: none;
              border-radius: 5px;
              padding-left: 8px;
              background-color: #ffffff;
            }
          }

          &:last-child {
            width: 100%;
            margin-bottom: 0;
          }
        }

        &:after {
          content: " ";
          display: block;
          clear: both;
        }
      }
    }
  }

  .ap-upload-pc {
    width: calc(100% - 20px);
    height: 185px;
    background: #f5f5f5;
    border-radius: 5px;
  }

  .ap-upload-m {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .upload-you {
      flex-direction: row;
      justify-content: flex-start;
      padding: 10px;
      box-sizing: border-box;
      width: 90%;
      height: 60px;
      border-radius: 5px;
      border: 1px solid #999;
      position: relative;

      .ff {
        width: 40px;
        min-width: 40px;
        margin-right: 8px;
      }

      .h3 {
        max-width: calc(100% - 76px);
      }

      .ti {
        position: absolute;
        top: 20px;
        right: 10px;
      }
    }

    .upload-xin {
      width: 74px;
      height: 74px;
      border: 1px dashed #d7d7d7;
      margin: 12px 0;

      img {
        width: 45px;
        height: 45px;
      }
    }
  }

  .upload-you {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    height: 100%;

    &.hide {
      display: none;
    }

    .ff {
      width: 45px;
      display: none;

      &.show {
        display: block;
      }

      img {
        width: 100%;
      }
    }

    .h3 {
      font-size: 16px;
      font-weight: bold;
      line-height: 40px;
      .cmEllipsis();
    }

    .ti {
      font-size: 12px;
      color: #999;
      line-height: 15px;

      span {
        cursor: pointer;
      }

      img {
        width: 20px;
        cursor: pointer;
      }
    }
  }

  .upload-xin {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    height: 100%;

    &.hide {
      display: none;
    }

    .h3 {
      font-size: 16px;
      font-weight: bold;
      line-height: 40px;
      .cmEllipsis();
    }

    .bx {
      padding: 5px 20px;
      border: 1px solid #ff5f00;
      border-radius: 5px;
      color: #ff5f00;
      margin: 5px 0 10px;
      .cmSelectNone();
    }

    .ti {
      font-size: 12px;
      color: #999;
      line-height: 15px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/s-apply/s-apply.vue